export const ENTITY_ENUM = {
	Job: 1,
	Quote: 2,
	Visit: 3,
	Invoice: 4,
	PurchaseOrder: 5,
	Asset: 6,
	PPMContract: 7,
	PPMQuote: 8,
	Supplier: 9,
	Engineer: 10,
	Part: 11,
	Equipment: 12,
	CGroupedInvoice: 13,
	PPMInvoice: 14
};

export const ENTITY_ENUM_KEY = Object.fromEntries(Object.entries(ENTITY_ENUM).map(a => a.reverse()));

export const SUBCONTRACTOR_KEY_NAME = {
	Subcontractor: 'Subcontractor',
	SubPO: 'Subcontractor PurchaseOrder',
	Allocation: 'Subcontractor Job Allocation',
	ContractPO: 'Contract PurchaseOrder'
};

export const SUBCONTRACTOR_MAPPING_KEY_NAME = {
	Receive: 'Receive',
	Accept: 'Accept',
	Reject: 'Reject',
	Transfer: 'Transfer',
	TransferPaperwork: 'Transfer Paperwork'
};

export const SUBCONTRACTOR_NAME_KEY = Object.fromEntries(Object.entries(SUBCONTRACTOR_KEY_NAME).map(a => a.reverse()));

export const ENTITY_SUBCONTRACTOR_ENUM = {
	Subcontractor: 1,
	'Subcontractor Job Allocation': 2,
	'Subcontractor PurchaseOrder': 3,
	'Contract PurchaseOrder': 4
};

export const ENTITY_SUBCONTRACTOR_ENUM_KEY = Object.fromEntries(Object.entries(ENTITY_SUBCONTRACTOR_ENUM).map(a => a.reverse()));

export const ENV_ENUM = {
	Uat: 1,
	Live: 2
};

export const ENV_ENUM_KEY = Object.fromEntries(Object.entries(ENV_ENUM).map(a => a.reverse()));

export const REQUEST_STATUS_ENUM = {
	All: 0,
	Success: 1,
	Failure: 2,
	'Rate Limit': 3
};

export const REQUEST_STATUS_ENUM_KEY = Object.fromEntries(Object.entries(REQUEST_STATUS_ENUM).map(a => a.reverse()));

export const STATISTIC_DATE_GROUP_TYPE = {
	Day: 0,
	Month: 1,
	Year: 2
};

export const TASK_TYPE = {
	PublicAPI: 1,
	ReportingAccess: 2,
	ProductUsage: 3
};

export const TRANSACTION_TYPE_ENUM = [
	{
		Id: 0,
		Description: 'Initial'
	},
	{
		Id: 1,
		Description: 'Addition'
	},
	{
		Id: 2,
		Description: 'Removal'
	},
	{
		Id: 3,
		Description: 'Decant'
	},
	{
		Id: 4,
		Description: 'Revert'
	},
	{
		Id: 5,
		Description: 'Correction'
	},
	{
		Id: 11,
		Description: 'Error Addition'
	},
	{
		Id: 12,
		Description: 'Error Removal'
	}
];

export const MODULES_ENUM = {
	Customer: 0,
	Site: 1,
	Quote: 2,
	Asset: 3,
	PurchaseOrder: 4
};

export const MODULES_LIST = Object.keys(MODULES_ENUM);

export const MODULES_ENUM_KEY = Object.fromEntries(Object.entries(MODULES_ENUM).map(a => a.reverse()));

export const ACTION_ENUM = {
	Other: 0,
	Create: 1,
	Read: 2,
	Update: 3,
	Delete: 4,
	Search: 5
};

export const REQUEST_STATUS = {
	Pending: 0,
	Cancelled: 2,
	Approved: 1
};

export const SUBSCRIPTION_ACTIVATION_TYPE_ENUM = {
	None: 0,
	Stripe: 1,
	GoCardless: 2
};

export const ORDER_DIRECTION = {
	asc: 1,
	desc: 2
};

export const ORDER_DIRECTION_VALUE = Object.fromEntries(Object.entries(ORDER_DIRECTION).map(a => a.reverse()));

export const TRANSACTION_TYPE = {
	Burned: 0,
	Refunded: 1,
	Purchased: 2,
	Revoked: 3,
	Expired: 4
};

export const TRANSACTION_TYPES = Object.keys(TRANSACTION_TYPE).map(item => ({
	Id: TRANSACTION_TYPE[item],
	Name: item
}));

export const OPERATOR_ENUM = {
	'=': 0,
	'<': 1,
	'<=': 2,
	'>=': 3,
	'>': 4
};

export const PAYMENT_METHOD_ENUM = {
	None: 0,
	Stripe: 1,
	GoCardless: 2
};

export const SUBSCRIPTION_STATUS_ENUM = {
	Active: 0,
	Canceled: 1,
	'Pending Cancel': 2,
	'Pending Activation': 3,
	Trialing: 4,
	'Locked Out': 5
};

export const SubscriptionStatusEnum = {
	Active: 'active',
	Cancelled: 'canceled',
	'Pending Cancellation': 'pending_cancel',
	'Pending Activation': 'pending_activation',
	Trialing: 'trialing',
	'Locked Out': 'locked_out'
};

export const PAYMENT_METHODS = {
	0: 'None',
	1: 'Stripe',
	2: 'GoCardless',
	3: 'Online'
};

export const CONTRACT_ITEM_TYPE = {
	License: 'License',
	Subcontractor: 'Subcontractor',
	JLPoint: 'JLPoint'
};

export const PAYMENT_INVOICE_STATUS = {
	None: 0,
	'Waiting For Payment': 1,
	'Payment Completed': 2,
	'Payment Failed': 3
};

export const PLATFORM_ENUM = {
	Web: 1,
	Mobile: 2,
	Hybrid: 3
	// Console: 4,
};

export const APP_TYPE_ENUM = {
	None: 0,
	Isolated: 1,
	Embedded: 2,
	Modular: 3
};

export const MOBILE_APP_TYPE_ENUM_SELECT = [
	{
		value: 1,
		label: 'Isolated',
		description: `The app operates as a standalone application, separate from the core JobLogic platform.
     It does not rely on or interact with JobLogic’s internal modules, allowing it to function independently.`
	},
	{
		value: 2,
		label: 'Embedded',
		description: `The app functions independently but can integrate with specific JobLogic modules if needed. 
    It maintains its standalone capabilities while gaining optional interoperability with certain JobLogic functionalities.`
	},
	{
		value: 3,
		label: 'Modular',
		description: `The app is tightly integrated with the JobLogic system. 
    Any code or feature updates in JobLogic directly impact the app, making it a dynamic part of the JobLogic ecosystem where changes are reflected across both systems.`
	}
];

export const APP_TYPE_ENUM_SELECT = [
	{
		value: 1,
		label: 'Isolated',
		description: `Your app will operate independently of the Joblogic System.
This option is best if your app is a standalone solution that functions separately from the Joblogic platform.`
	},
	{
		value: 2,
		label: 'Embedded',
		description: `Your app will appear integrated within the Joblogic System, providing a seamless user experience.
Although your app may have separate infrastructure, it behaves as part of the Joblogic platform from the user’s perspective.`
	},
	{
		value: 3,
		label: 'Modular',
		description: `Your app will function as a direct extension or module within the Joblogic System.
This option makes your app a core feature within Joblogic, enabled for specific customers with a unique module ID.`
	}
];

export const AUTHENTICATION_TYPE_ENUM = {
	None: 0,
	'Self Authentication': 1,
	'Token Authentication': 2
};

export const PRICE_TYPE_ENUM = {
	FREE: 0,
	FLEXIBLE: 1,
	SUBSCRIPTION: 2
};

export const LAUNCH_TYPE_ENUM = {
	Internal: 1,
	External: 2
};

export const APP_CONNECTIVITY_STATE_ENUM = {
	Online: 0,
	Offline: 1
};

export const CONTAINER_APP_STATUS_ENUM = {
	Running: 1,
	Stopped: 2,
	Waiting: 3,
	ActivationFailed: 4
};

export const COMPANY_PRODUCT_ENUM = {
	Legacy: 1,
	Enterprise: 2,
	FSM: 3,
	FSMPlus: 4,
	CAFM: 5,
	Clik: 6,
	Protean: 7
};

export const COMPANY_PRODUCT_SELECT = [
	{
		value: COMPANY_PRODUCT_ENUM.Legacy,
		label: 'Legacy'
	},
	{
		value: COMPANY_PRODUCT_ENUM.Enterprise,
		label: 'Enterprise'
	},
	{
		value: COMPANY_PRODUCT_ENUM.FSM,
		label: 'FSM'
	},
	{
		value: COMPANY_PRODUCT_ENUM.FSMPlus,
		label: 'FSM Plus'
	},
	{
		value: COMPANY_PRODUCT_ENUM.CAFM,
		label: 'CAFM'
	},
	{
		value: COMPANY_PRODUCT_ENUM.Clik,
		label: 'Clik'
	},
	{
		value: COMPANY_PRODUCT_ENUM.Protean,
		label: 'Protean'
	}
];
